import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Multiple methods to ensure scroll works
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        
        // Fallback
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
    }, [pathname]);

    return null;
};

export default ScrollToTop;
